import { useEffect } from "react";
import { Hooks } from "../layout/utils/hooks";
import { useAppSelector } from "../redux/hooks";
import { GlobalHooks } from "../utils/Hooks";
import { useParams } from 'react-router-dom';

const StatsUser = ({language ="fr", token}) => {
  const videoToken = useAppSelector((state) => state.LayoutReducer.STAT_VIDEO_URL)
  const {cookies} = GlobalHooks()
  const {getURLSTATVideo} = Hooks()
 const {id} = useParams()
  const OPTIONS = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Authorization" : "Bearer "+ cookies.authToken,
    },
  };

  const newStatsUser = "https:" +
    window.process.env.FO_STATS_URL 
    + "/statsUsers?lng=" + language + "&token=" + token
  
    return (
      <iframe
        id="iframe_stats_user"
        src={newStatsUser}
        allowFullScreen
        style={{ width: '100%', height: '98%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StatsUser